import {
  subscribeEvent,
  triggerEvent,
  unsubscribeEvent,
} from '@shared/event/event'
import type {
  SelectItemEvent,
  ViewItemEvent,
  ViewItemListEvent,
  ViewProductDetailEvent,
} from '@shared/event/events/types'
import type { EventCallback, EventToken } from '@shared/event/types'

const VIEW_PRODUCT_DETAIL_EVENT = 'view_product_detail'
const VIEW_ITEM_EVENT = 'view_item'
const VIEW_ITEM_LIST_EVENT = 'view_item_list'
const SELECT_ITEM_EVENT = 'select_item'

// Event trigger
export const triggerSelectItemEvent = (event: SelectItemEvent) =>
  triggerEvent(SELECT_ITEM_EVENT, event)

export const triggerViewProductDetailEvent = (event: ViewProductDetailEvent) =>
  triggerEvent(VIEW_PRODUCT_DETAIL_EVENT, event)

export const triggerViewItemEvent = (event: ViewItemEvent) =>
  triggerEvent(VIEW_ITEM_EVENT, event)

export const triggerViewItemListEvent = (event: ViewItemListEvent) =>
  triggerEvent(VIEW_ITEM_LIST_EVENT, event)

// Event Listener
export const onViewProductDetailEvent = (
  callback: EventCallback<ViewProductDetailEvent>
) => subscribeEvent(VIEW_PRODUCT_DETAIL_EVENT, callback)

export const onViewItemEvent = (callback: EventCallback<ViewItemEvent>) =>
  subscribeEvent(VIEW_ITEM_EVENT, callback)

export const onSelectItemEvent = (callback: EventCallback<SelectItemEvent>) =>
  subscribeEvent(SELECT_ITEM_EVENT, callback)

export const onViewItemListEvent = (
  callback: EventCallback<ViewItemListEvent>
) => subscribeEvent(VIEW_ITEM_LIST_EVENT, callback)

// Event remover
export const removeViewProductDetailEvent = (
  token: EventToken<ViewProductDetailEvent>
) => unsubscribeEvent(VIEW_PRODUCT_DETAIL_EVENT, token)

export const removeViewItemEvent = (token: EventToken<ViewItemEvent>) =>
  unsubscribeEvent(VIEW_ITEM_EVENT, token)

export const removeSelectItemEvent = (token: EventToken<SelectItemEvent>) =>
  unsubscribeEvent(SELECT_ITEM_EVENT, token)

export const removeViewItemListEvent = (token: EventToken<ViewItemListEvent>) =>
  unsubscribeEvent(VIEW_ITEM_LIST_EVENT, token)
